<template>
  <div class="PageBox">
    <div class="ScrollBox">
      <van-divider style="font-size: 14px">
        <i18n path="Withdraw[0]">
          <em style="color:var(--color-important);" slot="money">{{InitData.currency}}{{$Util.MoneyFormat(UserInfo.balance)}}</em>
        </i18n>
      </van-divider>
      <van-form label-width="80" @submit="onSubmit">
        <div style="margin: 12px;border-radius:10px;overflow:hidden;background-color:var(--background-main)">
          <input type="password" style="position: absolute;opacity: 0;z-index: -1">
          <van-field
            readonly
            :value="currBank"
            :label="$t('Withdraw[1]')"
            :placeholder="$t('Withdraw[2]')"
            right-icon="arrow-down"
            size="large"
            @click="showPicker=true"
          />
          <van-cell
            v-if="quickMoney"
            :title="$t('Withdraw[3]')" 
            size="large"
          >
            <template #label>
              <van-radio-group v-model="postData.draw_money" style="margin-top: 10px;">
                <a v-for="item,index in quickMoney.split(',')" :key="index" class="radio" :class="{active:$Util.PointFormat(item)==postData.draw_money}" href="javascript:;" @click="postData.draw_money=item">
                  {{$Util.MoneyFormat(item,true)}}
                  <van-radio v-show="false" :name="item" />
                </a>
              </van-radio-group>
            </template>
          </van-cell>
          <van-field
            v-else
            v-model.trim="postData.draw_money"
            type="number"
            :label="$t('Withdraw[3]')" 
            :placeholder="$t('Withdraw[4]')"
            size="large"
            clearable
          />
          <div class="rate-tips" v-if="postData.draw_type=='usdt'&&postData.draw_money" v-html="$t('Withdraw[10]',{currency:InitData.currency,rate: drawRate, price: postData.draw_money, money: parseInt(postData.draw_money/drawRate)})">
          </div>
          <div class="rate-tips" v-if="postData.draw_type=='bank'&&postData.draw_money">
            {{$t('Withdraw[13]')}}: {{postData.draw_money}}-{{postData.draw_money}}*{{UserInfo.withdrawal_fee}}%={{InitData.currency}}<b>{{$Util.PointFormat(postData.draw_money)-$Util.PointFormat(postData.draw_money)*UserInfo.withdrawal_fee/100}}</b>
          </div>
          <van-field
            v-if="postData.draw_type=='usdt'"
            :value="postData.address"
            :label="$t('Withdraw[5]')" 
            :placeholder="$t('Withdraw[6]')" 
            size="large"
            readonly
          />
          <van-field
            v-if="postData.draw_type=='bank'"
            v-model.trim="postData.phone"
            :label="$t('Withdraw[14]')" 
            :placeholder="$t('Withdraw[15]')" 
            size="large"
            clearable
            :readonly="UserInfo.phone?true:false"
          />
          <van-field
            v-if="postData.draw_type=='bank'"
            v-model.trim="postData.email"
            :label="$t('Withdraw[16]')" 
            :placeholder="$t('Withdraw[17]')" 
            size="large"
            clearable
            :readonly="UserInfo.mail?true:false"
          />
          <!-- <van-field
            v-if="postData.draw_type=='bank'"
            v-model.trim="postData.upi"
            :label="$t('Withdraw[18]')" 
            :placeholder="$t('Withdraw[19]')" 
            size="large"
            clearable
          /> -->
          <!-- <van-field
            v-if="InitData.setting&&(InitData.setting.withdraw_sms==1||InitData.setting.withdraw_mail==1)"
            v-model.trim="postData.code"
            type="digit"
            :label="$t('userInfo.label[8]')"
            :placeholder="$t('register.placeholder[6]')"
            clearable
            size="large"
          >
            <template #button>
              <van-image width="100" height="34" :src="codeImg" style="display: block;cursor: pointer;" @click="getCode" />
            </template>
          </van-field> -->
          <van-field
            v-if="InitData.setting&&InitData.setting.withdraw_sms==1"
            v-model.trim="postData.smscode"
            type="digit"
            :label="$t('userInfo.label[7]')" 
            :placeholder="$t('register.placeholder[1]')" 
            size="large"
            clearable
          >
            <template #button>
              <van-button size="mini" type="info" :color="isSendCode?'var(--color-assist)':''" round native-type="button" :disabled="isSendCode" @click="getSmsCode">{{$t('register.text[2]')}}{{isSendCode?`(${sendTime}s)`:''}}</van-button>
            </template>
          </van-field>
          <van-field
            v-if="InitData.setting&&InitData.setting.withdraw_mail==1"
            v-model.trim="postData.smscode"
            type="digit"
            :label="$t('Register[1][2]')" 
            :placeholder="$t('Register[1][0]')"
            clearable
            size="large"
          >
            <template #button>
              <van-button size="mini" type="info" :color="isSendCode?'var(--color-assist)':''" round native-type="button" :disabled="isSendCode" @click="getMailCode">{{$t('Register[1][1]')}}{{isSendCode?`(${sendTime}s)`:''}}</van-button>
            </template>
          </van-field>
          <van-field 
            v-model.trim="postData.drawword" 
            type="password"
            :label="$t('Withdraw[7]')" 
            :placeholder="$t('Withdraw[8]')" 
            size="large"
            clearable
          />
        </div>
        <div style="padding: 20px 12px;">
          <van-button block type="danger" round :loading="isSubmit" :loading-text="$t('dialog[2]')" style="font-size: 16px;">{{$t('Withdraw[9]')}}</van-button>
          <div style="text-align: center;margin: 20px 0 10px;color:var(--color-active);">{{$t('Withdraw[20]')}}</div>
          <van-button block color="#07c160" round style="font-size: 16px;" @click="$Util.OpenUrl($trustUrl)">{{$t('Withdraw[21]')}}</van-button>
        </div>
      </van-form>
      <div class="DrawTips" v-html="InitData.withdrawal_instructions"></div>
    </div>
    <!-- <van-popup v-model="showPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="cardList"
        @confirm="onConfirm"
        @cancel="showPicker=false"
      />
    </van-popup> -->
    <van-action-sheet v-model="showPicker" :title="$t('Withdraw[11]')">
      <van-radio-group v-model="postData.user_bank_id" checked-color="var(--color-active)" style="padding: 0 8px">
        <van-cell class="modelItem" v-for="(item,index) in cardList" :key="index" :border="false" @click="selectCard(item)">
          <template #icon>
            <img :src="`./static/icon/${item.mode}.png`" height="40" style="border-radius: 100%;margin-right: 10px">
          </template>
          <template #title>
            <b>{{item.name}}</b>
          </template>
          <template #label>
            {{item.card_no}}
          </template>
          <template #right-icon>
            <van-radio :name="item.id" />
          </template>
        </van-cell>
      </van-radio-group>
      <van-cell v-if="!BankCardList.length" :title="$t('Withdraw[12][0]')" is-link size="large" to="/user/bankCard" />
      <van-cell v-if="InitData.setting.usdt_withdrawal==1&&!UserInfo.usdtAddress" :title="$t('Withdraw[12][1]')" is-link size="large" to="/user/set/usdt" />
    </van-action-sheet>
  </div>
</template>

<script>
export default {
  name: 'Draw',
  components: {

  },
  props: [],
  data() {
    return {
      postData: {
        draw_type: '',
        user_bank_id: '',
        draw_money: this.$store.state.InitData.setting.min_w?this.$Util.PointFormat(this.$store.state.InitData.setting.min_w):'',
        address: '',
        smscode: '',
        phone: this.$store.state.UserInfo.phone||'',
        email: this.$store.state.UserInfo.mail||'',
        upi: '',
        drawword: ''
      },
      currBank: '',
      showPicker: false,
      isSubmit: false,
      virtualList: '',
      drawRate: '',
      codeImg: '',
      isSendCode: false,
      downTimer: null,
      sendTime: 60,
      quickMoney: '',
    }
  },
  computed: {
    cardList() {
      let card = this.$store.state.BankCardList.flatMap(item=>[{
        id: item.id,
        mode: "bank",
        name: item.bank_name,
        card_no: item.card_no.replace(/^(.{3}).*(.{3})$/, '$1 **** $2'),
        rate: 0
      }])
      let usdtCard = []
      if(this.$store.state.InitData.setting.usdt_withdrawal==1&&this.$store.state.UserInfo.usdtAddress){
        usdtCard = [{
          id: 0,
          mode: 'usdt',
          name: this.$store.state.UserInfo.usdtType,
          card_no: this.$store.state.UserInfo.usdtAddress,
          rate: this.$store.state.InitData.setting.usdtRate
        }]
      }
      card = card.concat(usdtCard)
      return card;
    }
  },
  watch: {

  },
  created() {
    this.$parent.navBarTitle = this.$t('wallet.default[2]')
    this.$Model.GetBankCardList((data)=>{
      this.quickMoney = data.fixed
    })
    // this.getCode()
    if(this.$store.state.UserInfo.is_fund_password!=1){
      this.$Dialog.Alert(this.$t('wallet.msg[0]'),()=>{
        this.$router.push('/user/info')
      })
    }
    if(this.$store.state.InitData.setting.withdraw_sms==1&&!this.$store.state.UserInfo.phone){
      this.$Dialog.Alert(this.$t('UserInfo[4]'),()=>{
        this.$router.push('/user/set/phone')
      })
    }
    if(this.$store.state.InitData.setting.withdraw_mail==1&&!this.$store.state.UserInfo.mail){
      this.$Dialog.Alert(this.$t('UserInfo[5]'),()=>{
        this.$router.push('/user/set/mail')
      })
    }
  },
  mounted() {

  },
  activated() {

  },
  destroyed() {
    clearInterval(this.downTimer)
  },
  methods: {
    getCode() {
      this.postData.code_rand = new Date().getTime()
      this.codeImg = this.ApiUrl+'/api/Account/code?code_rand='+this.postData.code_rand
    },
    countDown() {
      this.downTimer = setInterval(()=>{
        this.sendTime --
        if(this.sendTime<0){
          this.isSendCode = false
          this.sendTime = 60
          clearInterval(this.downTimer)
        }
      },1000)
    },
    getMailCode() {
      if(!this.$store.state.UserInfo.mail){
        this.$Dialog.Alert(this.$t('UserInfo[5]'),()=>{
          this.$router.push('/user/set/mail')
        })
        return
      }
      this.isSendCode = true;
      this.countDown()
      this.$Model.GetMailCode({mail: this.$store.state.UserInfo.mail, code: '', code_rand: '', type: 'withdraw',money: this.postData.draw_money},(data)=>{
        if(data.code!=1){
          // this.getCode()
        }else{
          this.$Dialog.Alert(data.code_dec)
        }
      })
    },
    getSmsCode() {
      if(!this.$store.state.UserInfo.phone){
        this.$Dialog.Alert(this.$t('UserInfo[4]'),()=>{
          this.$router.push('/user/set/phone')
        })
      }
      this.isSendCode = true
      this.countDown()
      this.$Model.GetSMSCode({phone: this.$store.state.UserInfo.phone,dest: this.$store.state.UserInfo.dest,code: '', code_rand: '',type: 'withdraw',money: this.postData.draw_money},(data)=>{
        if(data.code!=1){
          // this.getCode()
        }else{
          this.$Dialog.Alert(data.code_dec)
        }
      })
    },
    selectCard(data) {
      if(data.mode=='usdt'){
        if(this.$store.state.UserInfo.usdtAddress_state==1||this.$store.state.UserInfo.usdtAddress_state==3){
          this.$router.push('/user/set/usdt')
        }else{
          this.postData.address = data.card_no
        }
      }else{
        this.postData.address = ''
      }
      this.postData.user_bank_id = data.id
      this.postData.draw_type = data.mode
      this.drawRate = data.rate
      this.currBank = data.name
      this.showPicker = false
    },
    onSubmit() {
      if(this.postData.user_bank_id===''){
        this.$Dialog.Toast(this.$t('Withdraw[2]'));
        return;
      }
      if(!this.postData.draw_money){
        this.$Dialog.Toast(this.$t('Withdraw[4]'));
        return;
      }
      if(this.postData.draw_type=='bank'){
        if(!this.postData.phone){
          this.$Dialog.Toast(this.$t('Withdraw[15]'));
          return;
        }
        if(!this.postData.email){
          this.$Dialog.Toast(this.$t('Withdraw[17]'));
          return;
        }
        // if(!this.postData.upi){
        //   this.$Dialog.Toast(this.$t('Withdraw[19]'));
        //   return;
        // }
      }
      if(this.$store.state.InitData.setting.withdraw_sms==1&&!this.postData.smscode){
        this.$Dialog.Toast(this.$t('register.placeholder[1]'));
        return;
      }
      if(this.$store.state.InitData.setting.withdraw_mail==1&&!this.postData.smscode){
        this.$Dialog.Toast(this.$t('Register[1][0]'));
        return;
      }
      if(!this.postData.drawword){
        this.$Dialog.Toast(this.$t('Withdraw[8]'));
        return;
      }
      this.isSubmit = true;
      this.$Model.Draw(this.postData,data=>{
        this.isSubmit = false;
        this.$toast.clear()
        if(data.code==1){
          this.$router.push('/user/wallet/1')
        }else{
          this.$Dialog.Alert(data.code_dec)
        }
      })
    },
  }
}
</script>
<style scoped>
.DrawTips{
  padding: 12px;
}
.modelItem {
  background-color: var(--background-theme);
  border-radius: 12px;
  margin-bottom: 10px;
}
.modelItem .van-cell__title{
  line-height: 1;
}
.modelItem .van-cell__label{
  line-height: 1;
  margin-top: 8px;
}
.van-form .van-cell{
  padding: 16px;
}
.van-form .van-cell>>>.van-cell__title{
  font-weight: 600;
  color: var(--color-active);
  word-break: break-word;
}
.rate-tips{
  color: var(--color-assist);
  padding: 10px 16px;
  font-size: 12px;
}
.rate-tips>>>b{
  color: var(--color-important);
}
.van-radio-group{
  display: flex;
  flex-wrap: wrap;
}
.radio {
  color: var(--color-assist);
  border-radius: 3px;
  padding: 8px 5px;
  line-height: 1;
  min-width: 23.3%;
  margin: 3px 5px 3px 0;
  text-align: center;
  border: 1px solid var(--border-color-main);
  font-weight: 400;
}
.radio.active{
  color: var(--color-white);
  background-color: var(--color-active);
  border-color: var(--color-active);
}
</style>